import Phaser from "phaser";

export default class TransitionScene extends Phaser.Scene {
  constructor() {
    super("TransitionScene");
  }

  init(data) {
    this.label = data.label || "";
    this.nextScene = data.nextScene;
    this.nextData = data.nextData || {};
  }

  create() {
    this.cameras.main.setBackgroundColor("#06130c");

    const text = this.add
      .text(400, 300, this.label, {
        fontFamily: '"Russo One", sans-serif',
        fontSize: "34px",
        color: "#ecfccb",
        stroke: "#14532d",
        strokeThickness: 4,
        shadow: {
          offsetX: 0,
          offsetY: 3,
          color: "#020d07",
          blur: 6,
          fill: true,
        },
      })
      .setOrigin(0.5);

    this.tweens.add({
      targets: text,
      alpha: 0.35,
      duration: 220,
      yoyo: true,
      repeat: 3,
      ease: "steps(2)",
    });

    this.time.delayedCall(1400, () => {
      this.scene.start(this.nextScene, this.nextData);
    });
  }
}
